import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class ModalTemplate extends Vue {
    @Prop({ default: false }) public mandatoryChoice?: boolean;
}
